import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { getQuotaPromoUrl } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';
import { ButtonLink } from 'reactApp/ui/ButtonLink/ButtonLink';
import type { Props } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/SingleSpaceProgress.types';
import { useSpace } from 'reactApp/ui/Space/SingleSpace/SingleSpaceProgress/useSpace';

import styles from './SingleSpaceProgress.css';
import { SingleSpaceProgressBar } from './SingleSpaceProgressBar';
import { SpaceLabel } from './SpaceLabel';

export const SingleSpaceProgress = memo(
    ({
        isMobile = false,
        hideLabels = false,
        redWhenOverquota = false,
        quotaLink = false,
        legendAlign,
        legendSize,
        useSpaceHook = useSpace,
        isWrap,
        rebranding = false,
        isSubscriprionRebranding = false,
    }: Props): ReactElement => {
        const { isOverquota, spaceList, freeSpaceText, usedPercents } = useSpaceHook();
        return (
            <>
                <SingleSpaceProgressBar
                    spaceList={spaceList}
                    redWhenOverquota={redWhenOverquota}
                    rebranding={rebranding}
                    isOverquota={isOverquota}
                    freeSpaceText={freeSpaceText}
                    usedPercents={usedPercents}
                    isSubscriprionRebranding={isSubscriprionRebranding}
                />
                {!hideLabels && (
                    <>
                        <Spacing size={12} />
                        <div className={styles.legend}>
                            <div
                                className={classNames(styles.quotaInfo, {
                                    [styles.quotaInfo_mobile]: isMobile,
                                    [styles[`quotaInfo_wrap`]]: isWrap,
                                    [styles[`quotaInfo_${legendAlign}`]]: Boolean(legendAlign),
                                    [styles[`quotaInfo_${legendSize}`]]: Boolean(legendSize),
                                })}
                            >
                                {spaceList.map((item) => (
                                    <SpaceLabel
                                        id={item.id}
                                        key={item.id}
                                        isOverquota={item.isOverquota && !redWhenOverquota}
                                        text={item.text}
                                        hintText={item.hintText}
                                        onClick={item?.onClick}
                                        clickable={Boolean(item?.onClick)}
                                        rebranding={rebranding}
                                    />
                                ))}
                            </div>
                            {quotaLink && (
                                <ButtonLink
                                    primary
                                    className={styles.link}
                                    href={getQuotaPromoUrl({ hash: 'tariffs', query: PaymentUTM.spaceProgressFamily })}
                                    target="_blank"
                                    rel="noopener"
                                    hoverUnderline={false}
                                >
                                    Увеличить место
                                </ButtonLink>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    }
);

SingleSpaceProgress.displayName = 'SingleSpaceProgress';
